import React, { useEffect, useState } from 'react';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import GiangSuPageApi from "./GiangSuPageApi";
import { API_URL, FILE_URL } from './Constants';
import FtpFileBrowser from './FtpFileBrowser';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const Toggle = ({ value, onClick }) => (
  <div onClick={onClick} style={{ cursor: 'pointer', display: 'inline-block', width: '62px', height: '26px', position: 'relative', overflow: 'hidden', borderRadius: '3px' }}>
    <div style={{ width: '92px', position: 'relative', left: value ? '0' : '-31px', transition: 'left 0.2s', display: 'flex' }}>
      <span style={{ width: '31px', textAlign: 'center', background: '#4d90fe', color: '#fff', lineHeight: '26px', fontSize: '11px', fontWeight: 'bold' }}>ON</span>
      <span style={{ width: '30px', background: '#fff', border: '1px solid #ccc', lineHeight: '26px' }}>&nbsp;</span>
      <span style={{ width: '31px', textAlign: 'center', background: '#bbb', color: '#555', lineHeight: '26px', fontSize: '11px', fontWeight: 'bold' }}>OFF</span>
    </div>
  </div>
);

const AdminGuongSangTuHanhEditPage = ({ currentPostId, clickChangeMenu, postType = 11 }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');
  const [previewImage, setPreviewImage] = useState(null);
  const [showFtpBrowser, setShowFtpBrowser] = useState(false);

  const initialFormData = {
    postId: "", title: "", description: "",
    content: EditorState.createEmpty(),
    seoUrl: "", image: null, active: false,
    isNew: false, isHot: false, isHome: false, isSlide: false,
    sort: "",
    isDeleteFile: false, isDeleteImage: false, ftpImagePath: "", postType: postType,
    metaTitle: "", metaKeywords: "", metaDescription: ""
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    if (name === "title") {
      updated.seoUrl = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/ /g, "-");
    }
    setFormData(updated);
  };

  const handleEditorChange = (content) => setFormData(f => ({ ...f, content }));

  const uploadImageCallback = async (file) => {
    const fd = new FormData(); fd.append("image", file);
    try {
      const r = await fetch(API_URL + "/file/upload", { method: "POST", body: fd });
      const fn = await r.text();
      return { data: { link: FILE_URL + fn } };
    } catch { return { data: { link: "" } }; }
  };

  const handleFtpImageSelect = (file) => {
    setPreviewImage(FILE_URL + file.path);
    setFormData((f) => ({ ...f, image: null, ftpImagePath: file.path, isDeleteFile: true }));
    setShowFtpBrowser(false);
  };

  const handleDeleteImage = () => {
    setPreviewImage(null);
    setFormData(f => ({ ...f, image: null, ftpImagePath: "", isDeleteFile: true }));
  };

  const handleSubmit = async (mode = 'save') => {
    setIsLoading(true); setSaveMessage('');
    try {
      const response = currentPostId != null 
        ? await GiangSuPageApi.updatePost(formData) 
        : await GiangSuPageApi.submitPost(formData);
      
      if (response && response.status === 'ERROR') {
        setSaveMessage('Lưu thất bại: ' + (response.message || 'Lỗi hệ thống'));
      } else {
        setSaveMessage('Lưu thành công!');
        if (mode === 'save') setTimeout(() => clickChangeMenu && clickChangeMenu('gươngsángtuhành'), 1500);
        else if (mode === 'save-create') setTimeout(() => { setFormData(initialFormData); setIsActive(false); setPreviewImage(null); setSaveMessage(''); }, 1500);
        else setTimeout(() => setSaveMessage(''), 3000);
      }
    } catch { setSaveMessage('Lưu thất bại!'); }
    setIsLoading(false);
  };

  useEffect(() => {
    if (currentPostId != null) {
      GiangSuPageApi.getChiTietGiangSuAdmin(currentPostId, postType).then((data) => {
        if (data && data.length > 0) {
          const p = data[0];
          const blocksFromHTML = convertFromHTML(p.content || "");
          const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
          const updated = {
            postId: currentPostId, title: p.title, description: p.description || "",
            content: EditorState.createWithContent(contentState),
            seoUrl: p.slug_full, image: p.thumb, active: p.active,
            isNew: p.is_new || false,
            isHot: p.is_hot || false,
            isHome: p.is_home || false,
            isSlide: p.is_slide || false,
            sort: p.sort || "", isDeleteFile: false, isDeleteImage: false, ftpImagePath: "", postType: postType,
            metaTitle: p.meta_title || "", metaKeywords: p.meta_keywords || "", metaDescription: p.meta_description || ""
          };
          setFormData(updated); setIsActive(updated.active);
          if (p.thumb) {
            setPreviewImage(FILE_URL + p.thumb);
            if (p.thumb.startsWith('/linhquyphapan/files/')) setFormData(prev => ({ ...prev, ftpImagePath: p.thumb }));
          }
        }
      }).catch(console.error);
    }
  }, [currentPostId]);

  const actionButtons = (isBottom = false) => (
    <div className="btn-group">
      <button type="button" className="btn btn-success" onClick={() => handleSubmit('save')} disabled={isLoading}>
        {isBottom ? (currentPostId ? 'Sửa' : 'Tạo') : <><i className="icon-ok" /> {isLoading ? 'Đang lưu...' : 'Lưu'}</>}
      </button>
      <button type="button" className="btn" onClick={() => handleSubmit('save-edit')} disabled={isLoading}>Lưu và tiếp tục chỉnh sửa</button>
      <button type="button" className="btn" onClick={() => handleSubmit('save-create')} disabled={isLoading}>Lưu và tạo thêm Gương sáng tu hành</button>
      <button type="button" className="btn" onClick={() => clickChangeMenu && clickChangeMenu('gươngsángtuhành')}>Quay lại</button>
    </div>
  );

  return (
    <div>
      <div className="social-box" style={{ position: 'sticky', top: '40px', zIndex: 1000, boxShadow: '0px 2px 4px rgba(0,0,0,0.1)' }}>
        <div className="header">
          {actionButtons(false)}
          {saveMessage && <span style={{ marginLeft: '20px', color: saveMessage.includes('thành') ? 'green' : 'red', fontWeight: 'bold' }}>{saveMessage}</span>}
        </div>
      </div>

      <div className="social-box">
        <div className="form-horizontal" style={{ padding: '20px' }}>
          <h4 style={{ color: '#999', fontWeight: 'normal', margin: '0 0 10px', fontSize: '13px' }}>Thông tin chung</h4>
          <hr style={{ margin: '0 0 15px', borderColor: '#e5e5e5' }} />

          <div className="control-group">
            <label className="control-label">Tiêu đề:</label>
            <div className="controls"><input type="text" name="title" className="span12" value={formData.title} onChange={handleInputChange} /></div>
          </div>
          <div className="control-group">
            <label className="control-label">Tóm tắt:</label>
            <div className="controls"><textarea name="description" className="span12" rows="4" value={formData.description} onChange={handleInputChange} /></div>
          </div>
          <div className="control-group">
            <label className="control-label">Nội dung:</label>
            <div className="controls">
              <div className="span12" style={{ border: '1px solid #ddd' }}>
                <Editor
                  editorState={formData.content}
                  onEditorStateChange={handleEditorChange}
                  toolbar={{ image: { uploadCallback: uploadImageCallback, previewImage: true } }}
                  editorStyle={{ minHeight: '350px', padding: '10px', width: '100vw !important' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="social-box">
        <div className="form-horizontal" style={{ padding: '0 20px 20px' }}>
          <h4 style={{ color: '#999', fontWeight: 'normal', margin: '15px 0 10px', fontSize: '13px' }}>Thông tin</h4>
          <hr style={{ margin: '0 0 15px', borderColor: '#e5e5e5' }} />

          <div className="control-group">
            <label className="control-label">Hình ảnh:</label>
            <div className="controls">
              <div style={{ display: 'inline-flex', gap: '5px', alignItems: 'center' }}>
                <input type="text" readOnly className="span8" value={formData.ftpImagePath || (typeof formData.image === 'string' ? formData.image : '')} />
                <button type="button" className="btn" onClick={() => setShowFtpBrowser(true)}>Duyệt ảnh</button>
              </div>
              {previewImage && <div style={{ marginTop: '5px' }}><img src={previewImage} alt="Preview" style={{ maxWidth: '150px', maxHeight: '100px', border: '1px solid #ddd' }} /><button type="button" className="btn btn-danger btn-mini" style={{ marginLeft: '8px' }} onClick={handleDeleteImage}>Xóa</button></div>}
            </div>
          </div>

          <div className="control-group">
            <label className="control-label">Kích hoạt:</label>
            <div className="controls" style={{ paddingTop: '4px' }}><Toggle value={isActive} onClick={() => { const v = !isActive; setIsActive(v); setFormData(f => ({ ...f, active: v })); }} /></div>
          </div>

          <div className="control-group">
            <label className="control-label">Thứ tự:</label>
            <div className="controls"><input type="text" name="sort" className="span3" value={formData.sort} onChange={handleInputChange} /></div>
          </div>
        </div>
      </div>

      <div className="social-box">
        <div className="header">{actionButtons(true)}</div>
      </div>

      {showFtpBrowser && <FtpFileBrowser isOpen onClose={() => setShowFtpBrowser(false)} onSelectFile={handleFtpImageSelect} fileFilter={['.jpg','.jpeg','.png','.gif','.webp']} title="Chọn hình ảnh" />}
    </div>
  );
};

export default AdminGuongSangTuHanhEditPage;
